import { render, staticRenderFns } from "./RegionEditModal.vue?vue&type=template&id=0ede4424&scoped=true"
import script from "./RegionEditModal.vue?vue&type=script&lang=js"
export * from "./RegionEditModal.vue?vue&type=script&lang=js"
import style0 from "./RegionEditModal.vue?vue&type=style&index=0&id=0ede4424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ede4424",
  null
  
)

export default component.exports